import React from 'react';
import { makeStyles } from "@material-ui/core";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useNavigate } from 'react-router-dom';
import NotificationCard from "../components/notificationCard";
import ExamSeriesCard from "../components/examSeriesCard";

const useStyles = makeStyles((theme) => ({
    mainBlock: {
        marginLeft: -14,
        marginRight: -14,
        background: '#EFF5F4',
        '@media (min-width: 1025px)': {
            maxWidth: 700,
            margin: 'auto !important',
            border: '1px solid #eee',
        },
    },
    cardHeading: {
        color: '#8E9598',
        padding: 15,
        display: 'flex'
    }
}));
const ExamScreen = props => {
    const t = useTranslations();
    const classes = useStyles();
    const navigate = useNavigate();
    function goBack() {
        navigate('/my-app/exam-topic-screen');
    }

    return (
        <>
          <div className="mobile-back-to-test change-color">
                <ArrowBackIcon onClick={goBack}/>
                <span>Tier 1 - Mock Test</span>
          </div>
          <div className={classes.mainBlock}>
                <span className={classes.cardHeading}>FULL TESTS</span>
                <ExamSeriesCard />
                <ExamSeriesCard />
                <ExamSeriesCard />
                <NotificationCard />
                <NotificationCard />
          </div>
        </>
    );
};
export default ExamScreen;